import useVisible from "../../hooks/useVisible.jsx";
import handleClick from "../../utils/handleClick.js";

function DisableUnsupportedEffects({
  selectedTag,
  buttonTags,
  generateButtonTags,
}) {
  const [isVisible, setIsVisible] = useVisible(
    "DisableUnsupportedEffectsPremiereVisibility",
  );

  const [type, setType] = useVisible("DisableUnsupportedEffectsType");

  if (selectedTag && !buttonTags.includes(selectedTag)) {
    return null;
  }

  return (
    <>
      <li
        onClick={() => setIsVisible(!isVisible)}
        className={`button-card resolution-toggle ${isVisible ? "active" : ""}`}
      >
        <div className="button-card__icon">
          <i class="fa-light fa-eye-slash"></i>
          <div />
        </div>
        <div className="button-card__title">Disable Unsupported Effects</div>
        {generateButtonTags()}
      </li>
      <div className={`render-group ${isVisible ? "" : "hidden"}`}>
        <div className="render-group__checkbox-group">
        <div className="render-group__dropdown">
          <span className="render-group__dropdown-text">Impact</span>
          <select
            id="type"
            name="type"
            onChange={(event) => setType(event.target.value)}
            value={type}
          >
            <option value="comp">Comp</option>
            <option value="selected comp">Selected Comp</option>
            <option value="project">Project</option>
          </select>
        </div>
        </div>

        <div className="render-group__tools-grid">

        <div
          onClick={() =>
            handleClick("disableUnsupportedPremiereEffects", {
              enabled: false,
              type: type ? type : "comp",
            })
          }
          className="resolution-tools__button"
        >
          <i class="fa-light fa-eye-slash"></i>
          <span>Disable</span>
        </div>
        <div
          onClick={() =>
            handleClick("disableUnsupportedPremiereEffects", {
              enabled: true,
              type: type ? type : "comp",
            })
          }
          className="resolution-tools__button"
        >
          <i class="fa-sharp fa-light fa-eye"></i>
          <span>Enabled</span>
        </div>
        </div>
      </div>
    </>
  );
}

export default DisableUnsupportedEffects;
